import { render, staticRenderFns } from "./SubServiceForm.vue?vue&type=template&id=276fb1fd"
import script from "./SubServiceForm.vue?vue&type=script&lang=js"
export * from "./SubServiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports